import React from 'react';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import { Translation } from 'react-i18next';
import i18n from 'i18next';
import axios from 'axios';
import { debounce, get } from 'lodash';
import SchoolLogo from '../utility/SchoolLogo';
import HamburgerMenu from '../utility/HamburgerMenu';
import { isEmpty } from 'lodash';
import { education } from '../../copy/onboardingCopy.json';
import {
  getAuthState,
  getOnboardingState,
  getTenantState,
  getUserProfilePhoto,
  getAuthUserId,
} from '../../store/selectors';
import {
  getUserData,
  updateHasBeenToDashboard,
  getData,
  updateUserProfilePhoto,
  removeProfilePhoto,
  updateUserProgress,
  getFavoritesByUser,
} from '../../store/actions';
import { getHeaderListItems } from '../utility/headerUtil';
import GradCapIcon from '../utility/GradCapIcon';
import HomeIcon from '../utility/HomeIcon';
import AddPhotoIcon from '../utility/AddPhotoIcon';
import PersonIcon from '../utility/PersonIcon';
import RibbonIcon from '../utility/RibbonIcon';
import UserDashboardProgress from './utility/UserDashboardProgress';
import FavoriteIcon from '../utility/FavoriteIcon';
import me3LogoWhite from '../../ASUPhotos/logos/me3_logo_white.png';
import mcfLogo from '../../BaobabPhotos/logos/Baobab_MCF_Logo_whiteHeading.svg';
import Top3Careers from './Top3Careers';
import EditProfile from './EditProfile';
import ClassProgress from './ClassProgress';
import Top25Careers from './Top25Careers';
import RelatedCareers from './RelatedCareers';
import RiasecScore from './RiasecScore';
import Favorites from './Favorites';
import Loading from '../utility/Loading';
import ProfilePhotoDropdown from './ProfilePhotoDropdown';
import BlankUserPhoto from './utility/BlankUserPhoto';
import TakeActionLearnMore from './TakeActionLearnMore';
import BrightOutlookModal from '../utility/modal/BrightOutlookModal.jsx';
import LoginButton from '../utility/LoginButton';
import ReplaceCareerLink from '../career-path/utility/ReplaceCareerLink';
import SMCDashTakeAction from './SMCDashTakeAction';
import ASUPrepDigital from './utility/ASUPrepDigital';
import UpdateDataBanner from '../UpdateDataBanner';
import UniversalLearner from './UniversalLearner';
import { MyPath2ASU } from './MyPath2ASU';
import LanguageDropdown from '../LanguageDropdown';
import WindowTitle from '../utility/WindowTitle';

export class UserDashboard extends React.Component {
  _isMounted = false;

  constructor(props) {
    super(props);
    this.dashboard = React.createRef();
    this.classProgress = React.createRef();
    this.riasecScore = React.createRef();
    this.top25Careers = React.createRef();
    this.favorites = React.createRef();
    this.fileUpload = React.createRef();
    this.asuPrepDigital = React.createRef();
    this.state = {
      selectedComponent: 'dashboard',
      greetingMessage: i18n.t('Welcome'),
      isMobile: null,
      isTablet: null,
      loading: true,
      editProfilePhoto: false,
      showTransparentSpinner: false,
      showBrightOutlookModal: false,
      outOfDateData: false,
    };
  }

  get headingCopy() {
    return {
      profileProgress: i18n.t('Profile Progress'),
      dashboard: i18n.t('Dashboard'),
      classProgress: i18n.t('Class Progress'),
      myRiasecScore: i18n.t('My {{adjective}} Score', { adjective: 'RIASEC' }),
      myTopTF: i18n.t('My Top {{number}}', { number: '25' }),
      myFavorites: i18n.t('My Favorites'),
    };
  }

  get onboarding() {
    return this.props.onboarding;
  }

  get tenantName() {
    return this.props.tenant.name;
  }

  get educationLevel() {
    return get(this.onboarding, 'userData.user.educationLevel');
  }

  get authUserId() {
    return this.props.authUserId;
  }

  populateStore = async () => {
    const userId = this.authUserId;
    await this.props.getUserData(userId, this.props.auth.jwtToken);
    await this.props.getData(userId, this.props.auth.jwtToken);
    if (
      this.props.onboarding.userData.user.hasBeenToDashboard &&
      this._isMounted
    ) {
      this.setState({
        greetingMessage: i18n.t('Welcome Back'),
      });
    } else {
      await this.props.updateHasBeenToDashboard(this.props.auth.jwtToken);
    }
  };

  get canSeeEcap() {
    return (
      this.props.tenant.features.includes('highschool') &&
      this.props.onboarding.userData.user.country === 'United States' &&
      this.props.onboarding.userData.user.educationLevel === education.degree2
    );
  }

  get canSeeASUPrepDigital() {
    return (
      this.props.tenant.name === 'ASU' &&
      this.props.onboarding.userData.user.country === 'United States' &&
      this.props.onboarding.userData.user.educationLevel === education.degree2
    );
  }

  get canSeeMyPath2ASU() {
    return (
      [
        education.degree4,
        education.degree5,
        education.degree6,
        education.degree7,
      ].includes(this.props.onboarding.userData.user.educationLevel) &&
      this.props.tenant.name === 'ASU'
    );
  }

  componentDidMount = async () => {
    this._isMounted = true;
    window.addEventListener('resize', this.onWindowResize);
    const scrollbar = document.querySelector('.ScrollbarsCustom-Scroller');
    await this.populateStore();
    if (this._isMounted) {
      this.setState({
        loading: false,
        isMobile: window.innerWidth < 800,
        isTablet: window.innerWidth < 1180,
        outOfDateData: this.props.onboarding.userData.outOfDateData,
      });
    }
    scrollbar.addEventListener('scroll', () => this.handleScroll(scrollbar));
  };

  componentDidUpdate = () => {
    if (
      JSON.stringify(this.props.onboarding.userData.userProgress) !==
        JSON.stringify(this.state.userProgress) &&
      this.props.onboarding.userData.userProgress !== undefined &&
      this._isMounted
    ) {
      /* eslint-disable */
      this.setState({
        userProgress: this.props.onboarding.userData.userProgress,
      });
      /* eslint-enable */
    }
  };

  async componentWillUnmount() {
    this._isMounted = false;
    window.removeEventListener('resize', this.onWindowResize);
    const scrollbar = document.querySelector('.ScrollbarsCustom-Scroller');
    scrollbar.removeEventListener('scroll', () => this.handleScroll(scrollbar));
  }

  onWindowResize = debounce(() => {
    if (this._isMounted) {
      this.setState({
        isMobile: window.innerWidth < 800,
        isTablet: window.innerWidth < 1180,
      });
    }
  }, 50);

  colorPrimary = {
    color: `${this.props.tenant.primary}`,
  };

  buttonPrimary = {
    border: `1px solid ${this.props.tenant.primary}`,
    color: `${this.props.tenant.primary}`,
  };

  borderSecondary = {
    borderColor: `${this.props.tenant.secondary}`,
  };

  borderTransparent = {
    borderColor: `transparent`,
  };

  borderTopSecondary = {
    borderColor: `${this.props.tenant.secondary}`,
  };

  moveDown = {
    marginTop: '50px',
  };

  moveSidebarDown = {
    top: '61px',
  };

  numFallsWithinRange = (numToCheck, ref) => {
    const startingPoint = this.getStartingPoint(ref);
    const endPoint = this.getEndingPoint(ref, startingPoint);
    return numToCheck >= startingPoint && numToCheck <= endPoint;
  };

  getEndingPoint = (ref, startingPoint) => {
    if (ref.current && this._isMounted) {
      return startingPoint + ref.current.scrollHeight;
    }
  };

  getStartingPoint = (ref) => {
    const { isMobile } = this.state;
    let startingPoint = null;
    if (ref.current && this._isMounted) {
      startingPoint = isMobile
        ? ref.current.offsetTop + 95
        : ref.current.offsetTop;
    }
    return startingPoint;
  };

  handleScroll = async (vals) => {
    const { selectedComponent } = this.state;
    const currentPlace = vals.scrollTop + window.innerHeight / 2;
    let currentlyActiveElement = 'dashboard';
    if (
      this.classProgress.current &&
      this.numFallsWithinRange(currentPlace, this.classProgress)
    ) {
      currentlyActiveElement = 'classProgress';
    }
    if (this.numFallsWithinRange(currentPlace, this.riasecScore)) {
      currentlyActiveElement = 'myRiasecScore';
    }
    if (this.numFallsWithinRange(currentPlace, this.top25Careers)) {
      currentlyActiveElement = 'myTopTF';
    }
    if (currentPlace >= this.getStartingPoint(this.favorites)) {
      currentlyActiveElement = 'myFavorites';
    }
    if (selectedComponent !== currentlyActiveElement) {
      if (this._isMounted) {
        this.setState({
          selectedComponent: currentlyActiveElement,
        });
      }
    }
  };

  displayMenuForMobileOrDesktop = (isMobile) => (t) => {
    if (isMobile) {
      return (
        <>
          {this.displayTopOfMenu(t)}
          {this.displayBottomOfMenu(t)}
        </>
      );
    }
    return (
      <div
        className="menu-bar"
        style={this.state.outOfDateData ? this.moveSidebarDown : {}}
      >
        {this.displayTopOfMenu(t)}
        {this.displayBottomOfMenu(t)}
      </div>
    );
  };

  updateSelectedComponent = (headingId) => {
    if (this._isMounted) {
      this.setState({
        selectedComponent: headingId,
      });
    }
  };

  Icons = {
    dashboard: HomeIcon,
    classProgress: GradCapIcon,
    myRiasecScore: PersonIcon,
    myTopTF: RibbonIcon,
    myFavorites: FavoriteIcon,
  };

  returnIconComponent = (headingId) => (t) => {
    const { selectedComponent } = this.state;
    const Icon = this.Icons[headingId];
    if (!Icon) return <div className="no_block_type" />;
    return (
      <div
        className={[
          'menu-svg',
          headingId === 'dashboard' ? 'home-icon' : '',
        ].join(' ')}
      >
        <Icon color={selectedComponent === headingId ? 'black' : '#A7A7A7'} />
      </div>
    );
  };

  handleScrollToSection = (ref) => {
    const offset = this.getStartingPoint(ref);
    if (this.state.isMobile) {
      ref.current.scrollIntoView({
        behavior: 'smooth',
        top: offset,
      });
    } else {
      ref.current.scrollIntoView({
        behavior: 'smooth',
        top: offset,
      });
    }
    ref.current.focus({ preventScroll: true });
  };

  handleFile = async (file) => {
    // Remove the dropdown
    if (this._isMounted)
      this.setState({
        editProfilePhoto: false,
        showTransparentSpinner: true,
      });
    // User is uploading a profile photo
    if (file) {
      const BASE_URL = `${process.env.REACT_APP_API}`;
      const apiPath = `${BASE_URL}/tenant/2/user/${this.authUserId}`;
      const formData = new FormData();
      formData.append('image', file);
      await axios
        .post(apiPath, formData, {
          headers: {
            'Content-Type': 'multipart/form-data',
            Authorization: this.props.auth.jwtToken,
          },
        })
        .then(async (res) => {
          const options = { headers: { 'Content-Type': 'image/jpeg' } };
          try {
            const putResponse = await axios.put(
              res.data.data.uploadURL,
              file,
              options
            );
            const s3BucketAddress = putResponse.config.url.substr(
              0,
              putResponse.config.url.indexOf('?')
            );
            if (this._isMounted && res.data.data) {
              await this.props.updateUserProfilePhoto(
                this.authUserId,
                this.props.auth.jwtToken,
                s3BucketAddress
              );
              await this.props.updateUserProgress(this.props.auth.jwtToken, {
                added_photo: true,
              });
              this.setState({ showTransparentSpinner: false });
            }
          } catch (err) {
            console.log('s3 upload err: ', err);
          }
        });
    }
    // User selected to remove photo
    if (!file && this._isMounted) {
      await this.props.updateUserProgress(this.props.auth.jwtToken, {
        added_photo: false,
      });
      this.setState({ showTransparentSpinner: false });
    }
  };

  editProfilePic = () => {
    if (this._isMounted)
      this.setState((prevState) => ({
        editProfilePhoto: !prevState.editProfilePhoto,
      }));
  };

  displayTopOfMenu(t) {
    const { tenant } = this.props;
    return (
      <div className="user-profile">
        <LoginButton
          tenant={this.props.tenant}
          color={this.props.tenant.primary}
          isAuthenticated={this.props.auth.isAuthenticated}
          section="user dashboard"
          additionalClassNames="menu-log-out-mobile"
        />
        <div className="photo-and-edit-profile">
          <div className="profile-pic-container">
            {/* TODO: Use USER_PROFILE_PHOTO_FLAG instead of state to stop page rerender */}
            {this.props.userProfilePhoto ? (
              <img
                className="user-dashboard-profile-photo"
                src={this.props.userProfilePhoto}
                alt="user"
                onClick={this.editProfilePic}
                onKeyUp={this.editProfilePic}
                role="presentation"
              />
            ) : (
              <div className="white-circle">
                <BlankUserPhoto color={this.props.tenant.primary} />
              </div>
            )}
            <div
              id="edit-profile-menu"
              role="button"
              aria-haspopup="true"
              aria-controls="dropdown-menu2"
              aria-expanded={this.state.editProfilePhoto}
              tabIndex={0}
              onKeyDown={(e) => {
                if (['Enter'].includes(e.key)) this.editProfilePic();
              }}
              onClick={this.editProfilePic}
              className="plus-icon"
            >
              <AddPhotoIcon color={this.props.tenant.primary} />
            </div>
            {this.state.editProfilePhoto ? (
              <ProfilePhotoDropdown
                userId={this.authUserId}
                auth={this.props.auth}
                handleFile={(file) => this.handleFile(file)}
                editProfilePic={this.editProfilePic}
                editProfilePhoto={this.state.editProfilePhoto}
              />
            ) : null}
          </div>
          <div
            role="button"
            tabIndex={0}
            onClick={() => {
              this.props.history.push(
                `/${tenant.name.toLowerCase()}/edit-profile`
              );
            }}
            onKeyDown={(e) => {
              if (['Enter'].includes(e.key))
                this.props.history.push(
                  `/${tenant.name.toLowerCase()}/edit-profile`
                );
            }}
            className="edit-profile-link"
            style={this.colorPrimary}
          >
            {t('Edit Profile')}
          </div>
        </div>
        <div className="user-name">{`${this.props.onboarding.userData.user.firstName} ${this.props.onboarding.userData.user.lastName}`}</div>
        <UserDashboardProgress
          onboarding={this.props.onboarding}
          canSeeEcap={this.canSeeEcap}
          userProgress={this.state.userProgress}
          tenant={this.props.tenant}
        />
      </div>
    );
  }

  displayBottomOfMenu = (t) => {
    return (
      <>
        <div className="section-divider" />
        {this.props.endpoint === 'dashboard' ? (
          <div className="navigation-section" role="menu">
            {this.displayMenuItem('dashboard', true, this.dashboard)(t)}
            {this.canSeeEcap
              ? this.displayMenuItem(
                  'classProgress',
                  true,
                  this.classProgress
                )(t)
              : null}
            {this.displayMenuItem('myRiasecScore', true, this.riasecScore)(t)}
            {this.displayMenuItem('myTopTF', true, this.top25Careers)(t)}
            {this.displayMenuItem('myFavorites', false, this.favorites)(t)}
          </div>
        ) : null}
        <div className="section-divider" />
        <LoginButton
          tenant={this.props.tenant}
          color={this.props.tenant.primary}
          isAuthenticated={this.props.auth.isAuthenticated}
          section="user dashboard"
          additionalClassNames="button--primary menu-log-out"
        />
      </>
    );
  };

  displayMenuItem = (headingId, marginBottom, ref) => (t) => {
    const { selectedComponent } = this.state;
    return (
      <button
        type="button"
        role="menuitem"
        aria-label={
          headingId === selectedComponent
            ? `Click to jump to ${this.headingCopy[headingId]}. Selected`
            : `Click to jump to ${this.headingCopy[headingId]}. Unselected`
        }
        onClick={() => {
          this.handleScrollToSection(ref);
        }}
        className={
          marginBottom ? 'menu-item menu-item-margin-bottom' : 'menu-item'
        }
        style={
          headingId === selectedComponent
            ? this.borderSecondary
            : this.borderTransparent
        }
        data-cy={`user-dashboard-${this.headingCopy[headingId].replace(
          /\s+/g,
          ''
        )}`}
      >
        {this.returnIconComponent(headingId)(t)}
        <p
          className={
            headingId === selectedComponent
              ? 'dashboard-menu-heading'
              : 'dashboard-menu-heading unselected'
          }
        >
          {`${this.headingCopy[headingId]}`}
        </p>
      </button>
    );
  };

  setBrightOutlookModal = () => {
    this.setState((prevState) => ({
      showBrightOutlookModal: !prevState.showBrightOutlookModal,
    }));
  };

  get canSeeAdvisorDashboard() {
    return (
      this.props.onboarding.userData.user.role === 'Super User' ||
      this.props.onboarding.userData.user.role === 'Tenant Admin' ||
      this.props.onboarding.userData.user.role === 'District Advisor' ||
      this.props.onboarding.userData.user.role === 'School Advisor' ||
      this.props.onboarding.userData.user.role === 'College Advisor' ||
      this.props.onboarding.userData.user.role === 'College Advisor Manager'
    );
  }

  getListItems = () => {
    return getHeaderListItems({
      educationLevel: this.educationLevel,
      tenantName: this.tenantName,
      canSeeAdvisorDashboard: this.canSeeAdvisorDashboard,
      translations: true,
    });
  };

  render() {
    const { greetingMessage, isMobile, loading, showTransparentSpinner } =
      this.state;
    const { tenant } = this.props;
    if (loading || showTransparentSpinner || !this.props.onboarding.favorites)
      return <Loading height="100vh" />;
    return (
      <Translation>
        {(t) => (
          <>
            <WindowTitle>{t('Dashboard')}</WindowTitle>
            {this.state.outOfDateData && <UpdateDataBanner />}
            <div
              id="user-dashboard"
              tabIndex={-1}
              ref={this.dashboard}
              style={this.state.outOfDateData ? this.moveDown : {}}
            >
              {this.state.showBrightOutlookModal && (
                <BrightOutlookModal
                  tenant={this.props.tenant}
                  onClickParent={this.setBrightOutlookModal}
                />
              )}
              <div
                className="dashboard-header"
                style={this.borderTopSecondary}
                ref={this.header}
              >
                <div className="left-side-header">
                  <SchoolLogo />
                  <span className="right-left-side-header">
                    <ReplaceCareerLink tenant={this.props.tenant} />
                  </span>
                </div>
                <HamburgerMenu
                  tenant={tenant}
                  gtmLocation="dashboard hamburger menu"
                  listItems={this.getListItems()}
                />
              </div>
              <div className="menu-bar-and-page-content">
                {this.displayMenuForMobileOrDesktop(isMobile)(t)}
                {this.props.endpoint === 'dashboard' ? (
                  <div className="dashboard-page-content">
                    <div className="hero-image-container">
                      <img
                        className={
                          this.props.tenant.name === 'SMC'
                            ? 'dashboard-hero-image smc-dashboard-hero-image'
                            : 'dashboard-hero-image'
                        }
                        src={
                          tenant.dashboardHero
                            ? tenant.dashboardHero
                            : 'https://me3-photos-prod.s3-us-west-2.amazonaws.com/tenant_images/Dashboard-Hero-Default.png'
                        }
                        alt={`${tenant.terms_info.name} Hero`}
                        width="480"
                        height="400"
                      />
                      <div className="hero-image-overlay">
                        {/* <img
                          style={{ maxWidth: '40px' }}
                          src={me3LogoWhite}
                          alt="me3 Logo"
                        /> */}
                        <picture>
                          <source
                            media="(max-width: 799px)"
                            srcSet={me3LogoWhite}
                            width="480"
                            height="400"
                          />
                          <source
                            media="(min-width: 800px)"
                            srcSet={me3LogoWhite}
                            width="800"
                            height="400"
                          />
                          <img
                            style={{ maxWidth: '40px' }}
                            src={me3LogoWhite}
                            alt="me3 Logo"
                            width="800"
                            height="400"
                          />
                        </picture>
                        <h1 className="dashboard-greeting-message">
                          {greetingMessageForUser(
                            this.props.onboarding.userData.user.firstName.trim()
                          )}
                        </h1>
                      </div>
                      {this.props.tenant.name === 'Baobab' && (
                        <div className="baobab-mcf-logo-hero-overlay">
                          <img
                            src={mcfLogo}
                            alt="Mastercard Foundation logo"
                            style={{ width: '159px' }}
                          />
                        </div>
                      )}
                    </div>
                    {this.props.tenant.name === 'SMC' ? (
                      <SMCDashTakeAction tenant={this.props.tenant} />
                    ) : (
                      <TakeActionLearnMore
                        tenant={this.props.tenant}
                        userInHighSchool={
                          this.props.onboarding.userData.user.educationLevel ===
                          education.degree2
                        }
                        userProgress={
                          this.props.onboarding.userData.userProgress
                        }
                        degreeChoices={this.props.onboarding.degreeChoices}
                      />
                    )}
                    <Top3Careers
                      tenant={this.props.tenant}
                      setBrightOutlookModal={this.setBrightOutlookModal}
                    />
                    <div className="section-divider" />
                    {this.canSeeEcap && !this.canSeeASUPrepDigital && (
                      <div
                        ref={this.classProgress}
                        tabIndex={-1}
                        id="classProgress"
                      >
                        <ClassProgress tenant={this.props.tenant} />
                        <div className="section-divider" />
                      </div>
                    )}
                    {this.canSeeASUPrepDigital && this.canSeeEcap && (
                      <div
                        ref={this.classProgress}
                        tabIndex={-1}
                        id="classProgress"
                      >
                        <ClassProgress tenant={this.props.tenant} />
                        <div className="section-divider" />
                        <ASUPrepDigital tenant={this.props.tenant} />
                        <div className="section-divider" />
                      </div>
                    )}
                    {/* Adding <RelatedCareers /> into the
                  riasecScore ref for navigation purposes
                  If we add navigation for RelatedCareers to side menu
                  Then we can change this */}
                    <div ref={this.riasecScore} tabIndex={-1} id="riasecScore">
                      <RiasecScore
                        isMobile={this.state.isMobile}
                        isTablet={this.state.isTablet}
                        history={this.props.history}
                        location={this.props.location}
                        tenant={this.props.tenant}
                      />
                      <div className="section-divider" />
                      {this.canSeeMyPath2ASU && (
                        // eslint-disable-next-line
                        <>
                          <MyPath2ASU tenant={this.props.tenant} />
                          <div className="section-divider" />
                        </>
                      )}
                      {this.props.tenant.name === 'ASU' &&
                        [
                          education.degree2,
                          education.degree3,
                          education.degree4,
                          education.degree5,
                          education.degree6,
                        ].includes(
                          this.props.onboarding.userData.user.educationLevel
                        ) && (
                          // eslint-disable-next-line
                          <>
                            <UniversalLearner
                              tenant={this.props.tenant}
                              setBrightOutlookModal={this.setBrightOutlookModal}
                            />
                            <div className="section-divider" />
                          </>
                        )}
                      <RelatedCareers
                        tenant={this.props.tenant}
                        setBrightOutlookModal={this.setBrightOutlookModal}
                      />
                      <div className="section-divider" />
                    </div>

                    <div ref={this.top25Careers} id="top25CareerRef">
                      <Top25Careers tenant={this.props.tenant} />
                      <div className="section-divider" />
                    </div>
                    <div ref={this.favorites} tabIndex={-1} id="favorites">
                      <Favorites
                        tenant={this.props.tenant}
                        favorites={this.props.onboarding.favorites}
                        getFavorites={this.props.getFavoritesByUser}
                        userId={this.props.onboarding.userData.user.id}
                        location={this.props.location}
                      />
                    </div>
                  </div>
                ) : (
                  <div className="dashboard-page-content">
                    <EditProfile
                      tenant={this.props.tenant}
                      auth={this.props.auth}
                      user={this.props.onboarding.userData.user}
                    />
                  </div>
                )}
              </div>
            </div>
          </>
        )}
      </Translation>
    );
  }
}

const mapStateToProps = (state) => {
  const onboarding = getOnboardingState(state);
  const tenant = getTenantState(state);
  const auth = getAuthState(state);
  const userProfilePhoto = getUserProfilePhoto(state);
  const authUserId = getAuthUserId(state);
  return { tenant, onboarding, auth, userProfilePhoto, authUserId };
};

const greetingMessageForUser = (firstName = null) => {
  if (!isEmpty(firstName)) return `${i18n.t('Welcome Back')}, ${firstName}`;
  return i18n.t('Welcome Back');
};

const DashboardWithRouter = withRouter(
  connect(mapStateToProps, {
    getUserData,
    getData,
    updateHasBeenToDashboard,
    updateUserProfilePhoto,
    removeProfilePhoto,
    updateUserProgress,
    getFavoritesByUser,
  })(UserDashboard)
);

export default DashboardWithRouter;
